import React, { useEffect, useMemo, useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import {
  Box,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Grid,
  styled,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import * as Yup from "yup";
import {
  MoveToInbox as InboxIcon,
  Mail as MailIcon,
  QuestionMark as QuestionMarkIcon,
  Logout as LogoutIcon,
  Close as CloseIcon,
  ChevronRight as Rightarrow,
  ChevronLeft as Leftarrow,
  BuildOutlined,
  Diversity1Outlined,
  SmsOutlined,
  ThreePOutlined,
  ContactMailOutlined,
  SocialDistanceOutlined,
  MultipleStopOutlined,
  NextPlanOutlined,
  CalendarMonthOutlined,
  DescriptionOutlined,
  HolidayVillage as HolidayVillageIcon,
  WindowSharp,
  SmsOutlined as SmsIcon,
  EmailOutlined,
  AirlineSeatReclineNormal,
  Badge,
  WorkspacePremiumOutlined,
} from "@mui/icons-material";
import { useLocation, Link } from "react-router-dom";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import sidebarfooter from "../../assets/img/sidebarfooter.png";
import sidebarlogo from "../../assets/img/sidebar_logo.png";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import ModalWrapper from "@/components/forms/ModalWrapper";
import { MoneyIcon, TipsAndUpdatesIcon } from "@/icons";
import GroupsIcon from "@mui/icons-material/Groups";
import menuItems from "./menulist";
import DynamicIcon from "./dynamiIcons";
import { getSpocStatus, handleUnauthorizedError } from "@/utils/authUtils";
import DialogForm from "../modal/DialogForm";
import HelpDeskModel from "../modal/HelpDeskModel";
import useFetchCommonData from "@/hooks/useFetchCommonData";
import FormikSelectInput from "../forms/FormikSelectInput";
import FormikTextarea from "../forms/FormikTextarea";
import FormikFileUpload from "../forms/FormikFileUpload";
import { useFetchMenuSubmenuQuery } from "@/api/services/helpdesk/help_desk/HelpDeskSpoc";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SubmitButtonWithLoader from "../forms/SubmitButtonWithLoader";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import helpdeskIcon from "../../assets/img/HelpDeskIcon2.svg";
import {
  usePostRaiseTicketMutation,
  useFetchRaiseTicketMenuListQuery,
  useFetchCategoryListQuery,
} from "@/api/services/helpdesk/help_desk/RaiseTicket";
import { useFetchModuleSettingsDataQuery } from "@/api/services/Settings/business/Business";
import { toast } from "@/components/toastify";
import { jwtDecode } from "jwt-decode";
import CryptoJS from "crypto-js";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "black",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "black",
    borderRadius: 0,
    maxWidth: "70px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    textAlign: "center",
    padding: 5,
  },
}));

const generateCaptcha = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789";
  let text = "";
  for (let i = 0; i < 6; i++) {
    text += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return text;
};

const DrawerComponent = ({
  mobileOpen,
  handleDrawerClose,
  handleDrawerTransitionEnd,
  container,
}) => {
  const location = useLocation(); // Get the current location
  const drawerWidth = 80;
  const [selectedMenu, setSelectedMenu] = useState([]);
  const [submenutitle, setSubMenuTitle] = useState("");
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [ticketRaised, setTicketRaised] = useState("My Self");
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedMenuId, setSelectedMenuId] = useState("");
  const isSpocUser = getSpocStatus();
  const [captchaText, setCaptchaText] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [initialValues, setInitialValues] = useState({
    reason: "",
    ticketRaisedFor: "My Self",
    menu: "",
    employeeList: "",
    modeOfCommunication: "",
  });

  const { data: fetchMenu } = useFetchRaiseTicketMenuListQuery(selectedMenuId, {
    skip: !isOpen,
  });
  const { data: fetchCategoryList } = useFetchCategoryListQuery(undefined, {
    skip: !isOpen,
  });

  const { data: fetchAllEmployees } = useFetchCommonData("EMPLOYEES", {
    skip: !isOpen || ticketRaised === "My Self",
  });
  // const { data: menuOption, isLoading: isMenusLoading } =
  //   useFetchMenuSubmenuQuery();
  // const { data: submenuOption = [] } = useFetchMenuSubmenuQuery(
  //   selectedMenuId,
  //   {
  //     skip: !selectedMenuId,
  //   }
  // );
  // console.log("fetchAllEmployees", fetchAllEmployees);
  const [raiseTicket, { isLoading: loading }] = usePostRaiseTicketMutation();
  const { data: modeOfCommunicationData } = useFetchModuleSettingsDataQuery(
    "ModeOfCommunication",
    { skip: !isOpen || !isSpocUser },
  );

  const modeOfCommunicationOptions =
    modeOfCommunicationData?.data?.map((item) => ({
      label: item.modeOfCommunication || item.name || item.value,
      value:
        item.modeOfCommunication || item.name || item.value || item.moduleId,
    })) || [];

  const allMenuOptions =
    fetchCategoryList?.menuData?.map((menu) => ({
      label: menu.menuName,
      value: menu.commonId,
      // data: menu.menuId,
    })) || [];
  const submenuOptions =
    fetchMenu?.subMenuData?.map((menu) => ({
      label: menu.subMenuName,
      value: menu.commonId,
      // data: menu.menuId,
    })) || [];

  const handleMenuClick = (menu, submenu, title) => {
    setSelectedMenu(menu);
    setSubMenuTitle(title);
    setSubMenuOpen(submenu);
  };
  const handleOpenModal = (row = null) => {
    setOpen(true);
  };

  const handleSubMenuClose = () => {
    setSubMenuOpen(false);
    setSelectedMenu([]);
  };

  const role = localStorage.getItem("role");

  const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));

  const isMicrosoftLogin = localStorage.getItem("isMicrosoftAuthencated");

  const menuss = localStorageData?.userDetails?.permission?.filter((item) => {
    if (isMicrosoftLogin !== "true" && item?.text === "Meeting Calendar") {
      return false;
    }
    return true;
  });

  const ENCR_DECR_KEY = "cavin*info*tech@";
  const encryptEmail = (email) => {
    const key = CryptoJS.enc.Utf8.parse(ENCR_DECR_KEY);

    const encrypted = CryptoJS.AES.encrypt(email, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString(); // Base64 string
  };

  const [showAllMenus, setShowAllMenus] = useState(true);
  const visibleMenus = showAllMenus ? menuss : menuss.slice(0, 6);

  const deval = jwtDecode(localStorageData?.token);
  // console.log("deval", deval);

  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setCaptchaText(generateCaptcha());
      setCaptchaInput("");
      setCaptchaError("");
    }
  };

  const handleHelpSubmit = async (values, resetForm) => {
    if (captchaInput !== captchaText) {
      setCaptchaError("Incorrect CAPTCHA. Please try again.");
      setCaptchaText(generateCaptcha());
      setCaptchaInput("");
      return;
    }
    setCaptchaError("");
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append(
        "selfRequest",
        values.ticketRaisedFor === "My Self" ? "Yes" : "No",
      );
      if (values.employeeList) {
        formData.append("forEmpId", values.employeeList);
      }
      formData.append("commonId", values.menu);
      formData.append("ticketDetails", values.reason);
      if (isSpocUser && values.modeOfCommunication) {
        formData.append("modeOfCommunication", values.modeOfCommunication);
      }
      if (values.file) {
        formData.append("file", values.file);
      }

      try {
        const response = await raiseTicket(formData).unwrap();
        setIsOpen(false);
        setIsSubmitting(false);
        toast("success", "Ticket Raised successfully");
        resetForm();
      } catch (error) {
        // const errorMessage = error?.data?.message || "Failed to Raise Ticket";
        // toast("error", errorMessage);
        // setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setIsSubmitting(false);
    }
  };
  const empOptions =
    (fetchAllEmployees &&
      fetchAllEmployees.map((item) => ({
        value: item.empId,
        label: item.employeeName,
      }))) ||
    [];
  const validationSchema = Yup.object().shape({
    reason: Yup.string().required("Please Enter the reason!"),
    ticketRaisedFor: Yup.string().required("Please Select the Raised For!"),
    menu: Yup.string().required("Please Enter the Category!"),
    modeOfCommunication: isSpocUser
      ? Yup.string().required("Please Select Mode of Communication!")
      : Yup.string().notRequired(),
    // subMenu: Yup.string().required("Please Enter the Sub-Category!"),
    employeeList: Yup.string().when("ticketRaisedFor", {
      is: (val) => val === "Others",
      then: (schema) => schema.required("Please enter the employee list!"),
    }),
  });
  // const validationSchemaTwo = Yup.object().shape({
  //   reason: Yup.string().required("Please Enter the reason!"),
  //   ticketRaisedFor: Yup.string().required("Please Select the Raised For!"),
  //   employeeList: Yup.string().required("Please Enter the employeeList!"),
  // });
  // const validationSchemaToUse = useMemo(() => {
  //   return ticketRaised === "My Self" ? validationSchema : validationSchemaTwo;
  // }, [ticketRaised]);
  const typeOptions = ["My Self", "Others"];
  // const categoryOptions = ["Menu", "Category"];

  const fields = [
    {
      label: "Ticket Raised For",
      name: "ticketRaisedFor", // ✅ changed
      type: "select",
      options: [
        { label: "User", value: "user" },
        { label: "Admin", value: "admin" },
      ],
      placeholder: "Select Raised For",
      required: true,
    },
    {
      label: "Category",
      name: "category", // ✅ changed
      type: "select",
      options: [
        { label: "Document 1", value: "doc1" },
        { label: "Document 2", value: "doc2" },
      ],
      placeholder: "Select Category",
      required: true,
    },
    {
      label: "Reason",
      name: "reason",
      type: "textArea",
      placeholder: "Enter Reason",
      required: true,
    },
    {
      label: "File Upload",
      name: "file",
      type: "file",
      placeholder: "Add Attachment",
      required: false,
    },
  ];
  // const initialValues = {
  //   reason: "",
  //   ticketRaisedFor: "My Self",
  //   menu: "",
  //   subMenu: "",
  //   employeeList: "",
  // };
  // const menuItems = [

  //   {
  //     text: "Dashboard",
  //     path: "/dashboard",
  //     submenu: [],
  //     icon: <WindowSharp />,
  //   },
  //   {
  //     text: "Profile",
  //     path: "/profile",
  //     submenu: [
  //       {
  //         text: "BasicDetails",
  //         path: "/profile",
  //         child: [],
  //       },
  //       {
  //         text: "ContactDetails",
  //         path: "/contact",
  //         child: [],
  //       },
  //       {
  //         text: "WorkDetails",
  //         path: "/workinformation",
  //         child: [],
  //       },
  //       {
  //         text: "HrDetails",
  //         path: "/hrinformation",
  //         child: [],
  //       },
  //       {
  //         text: "AccountDetails",
  //         path: "/accountinformation",
  //         child: [],
  //       },
  //       {
  //         text: "EducationDetails",
  //         path: "/educationinformation",
  //         child: [],
  //       },
  //       {
  //         text: "ExperienceDetails",
  //         path: "/experience",
  //         child: [],
  //       },
  //       {
  //         text: "FamilyDetails",
  //         path: "/family",
  //         child: [],
  //       },
  //       {
  //         text: "FollowupDetails",
  //         path: "/followup",
  //         child: [],
  //       },

  //     ],
  //     icon: <ThreePOutlined />,
  //   },
  //   {
  //     text: "people",
  //     path: "/myteams",
  //     icon: <Diversity1Outlined />,
  //     submenu: [
  //       {
  //         text: "My Teams",
  //         path: "/myteams",
  //         child: [{ text: "My Teams", path: "/myteams" }],
  //       },
  //       {
  //         text: "Org Chart",
  //         path: "/chart",
  //         child: [{ text: "Org Chart", path: "/chart" }],
  //       },
  //       {
  //         text: "Employee",
  //         path: "/employee",
  //         child: [{ text: "Employee", path: "/employee" }],
  //       },
  //     ],
  //   },
  //   {
  //     text: "leave",
  //     path: "/leave",
  //     submenu: [],
  //     icon: <CalendarMonthOutlined />,
  //   },
  //   {
  //     text: "Attendance",
  //     path: "/attendance",
  //     submenu: [],
  //     icon: <CalendarMonthOutlined />,
  //   },
  //   {
  //     text: "Probation",
  //     path: "/currentProbation",
  //     submenu: [
  //       {
  //         text: "Current Probation",
  //         path: "/currentProbation",
  //         child: [],
  //       },
  //       {
  //         text: "Extended Probation",
  //         path: "/extendedProbation",
  //         child: [],
  //       },
  //       {
  //         text: "Confirmed Probation",
  //         path: "/confirmedProbation",
  //         child: [],
  //       },
  //     ],
  //     icon: <ContactMailOutlined />,
  //   },
  //   {
  //     text: "Movement",
  //     path: "/movementInitiate",
  //     submenu: [
  //       {
  //         text: "Movement",
  //         path: "/movementInitiate",
  //         child: [],
  //       },
  //       {
  //         text: "My Team",
  //         path: "/reportingManager",
  //         child: [],
  //       },
  //     ],
  //     icon: <MultipleStopOutlined />,
  //   },
  //   {
  //     text: "Events",
  //     path: "/event",
  //     submenu: [],
  //     icon: <CalendarMonthOutlined />,
  //   },
  //   {
  //     text: "Holiday",
  //     path: "/empHolidays",
  //     submenu: [
  //       {
  //         text: "View All",
  //         path: "/empHolidays",
  //         child: [],
  //       },
  //       {
  //         text: "Restricted Holiday",
  //         path: "/empRestrictedHoliday",
  //         child: [],
  //       },
  //       {
  //         text: "Holiday",
  //         path: "/empViewHoliday",
  //         child: [],
  //       },
  //     ],
  //     icon: <HolidayVillageIcon />,
  //   },
  //   {
  //     text: "Colleague Birthday",
  //     path: "/dashboard/colleagueBirthday",
  //     submenu: [],
  //     icon: <CalendarMonthOutlined />
  //   },
  //   {
  //     text: "Work Anniversary",
  //     path: "/dashboard/workAnniversary",
  //     submenu: [],
  //     icon: <Diversity1Outlined />
  //   },
  //   {
  //     text: "Policy",
  //     path: "/policy",
  //     submenu: [],
  //     icon: <HolidayVillageIcon />,
  //   },
  //   {
  //     text: "Separation",
  //     path: "/separation",
  //     submenu: [],
  //     icon: <NextPlanOutlined />,
  //   },
  //   {
  //     text: "Help Desk",
  //     path: "/helpdesk",
  //     icon: <SmsOutlined />,
  //     submenu: [
  //       {
  //         text: "Help Desk",
  //         path: "/helpdesk",
  //         child: [{ text: "Help Desk", path: "/helpdesk" }],
  //       },
  //     ],
  //   },
  //   {
  //     text: "Travel Claims",
  //     path: "/travel",
  //     submenu: [],
  //     icon: <DescriptionOutlined />,
  //   },
  //   {
  //     text: "Settings",
  //     path: "/business",
  //     icon: <BuildOutlined />,
  //     submenu: [
  //       {
  //         text: "Business",
  //         path: "/business",
  //         child: [{ text: "Business", path: "/business" }],
  //       },

  //     ],
  //   },
  //   {
  //     text: "Employee List",
  //     path: "/employeeList",
  //     submenu: [],
  //     icon: <Badge />,
  //   },
  //   {
  //     text: "Attendance Management",
  //     path: "/adminAttendanceInfo",
  //     submenu: [],
  //     icon: <CalendarMonthOutlined />
  //   },
  //   {
  //     text: "Leave Management",
  //     path: "/leaveManagement",
  //     submenu: [],
  //     icon: <DescriptionOutlined />
  //   },
  //   {
  //     text: "Help Desk Report",
  //     path: "/helpDeskReport",
  //     submenu: [],
  //     icon: <SmsOutlined />
  //   },
  //   {
  //     text: "Hr Movement",
  //     path: "/hrMovement",
  //     submenu: [],
  //     icon: <SmsOutlined />
  //   },
  //   {
  //     text: "Email Id Creation",
  //     path: "/emailIdCreation",
  //     submenu: [],
  //     icon: <EmailOutlined />,
  //   },
  //   {
  //     text: "Candidate Seating",
  //     path: "/candidateSeating",
  //     submenu: [],
  //     icon: <AirlineSeatReclineNormal />,
  //   },
  //   {
  //     text: "OnBoarding",
  //     path: "/onBoarding",
  //     submenu: [],
  //     icon: <GroupsIcon />
  //   },
  //   {
  //     text: "Candidate OnBoarding",
  //     path: "/canditateOnboarding",
  //     submenu: [],
  //     icon: <GroupsIcon />
  //   },
  //   {
  //     text: "Payroll",
  //     path: "/payrollEsic",
  //     submenu: [],
  //     icon: <MoneyIcon />
  //   },
  //   {
  //     text: "Salary",
  //     path: "/Payslip",
  //     submenu: [
  //       {
  //         text: "Payslip",
  //         path: "/payslip",
  //         child: [],
  //       },
  //       {
  //         text: "ItDeclaration",
  //         path: "/itdeclaration",
  //         child: [],
  //       },
  //       {
  //         text: "EmpFbp",
  //         path: "/fbpemp",
  //         child: [],
  //       },
  //       {
  //         text: "ReimbursementClaims",
  //         path: "/reimbursementclaims",
  //         child: [],
  //       },
  //     ],
  //     icon: <MoneyIcon />
  //   },
  //   {
  //     text: "HR Probation",
  //     path: "/hrProbation",
  //     submenu: [],
  //     icon: <ContactMailOutlined />
  //   },
  //   {
  //     text: "Performance",
  //     path: "/performance",
  //     submenu: [],
  //     icon: <WorkspacePremiumOutlined />
  //   },
  //   {
  //     text: "Project Wave",
  //     path: "/projectwave",
  //     submenu: [],
  //     icon: <TipsAndUpdatesIcon />
  //   },
  // ];
  const handleLogout = () => {
    toast("success", "Logged out successfully");

    setTimeout(() => {
      handleUnauthorizedError();
    }, 1000);
  };
  const SECRET_KEY =
    "ec0b660fb30c104b59f43621985d4d8a702577de14622da466682159bb94b971";

  const generateOKRSSOToken = (email, secretKey) => {
    if (!secretKey) {
      throw new Error("Secret Key is missing");
    }

    const key = CryptoJS.SHA256(secretKey);

    const iv = CryptoJS.lib.WordArray.create(key.words.slice(0, 4), 16);

    const finalPayload = {
      email: email,
      timestamp: Math.floor(Date.now() / 1000),
    };

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(finalPayload), key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).ciphertext.toString(CryptoJS.enc.Base64);
    const url = `https://okr.cavinkare.in/sso-login?token=${encodeURIComponent(encrypted)}`;
    window.open(url, "_blank");
  };

  const mainDrawer = (
    <Box
      sx={(theme) => {
        return {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          background: theme.palette.gradient.primary,
          borderTopRightRadius: "60px",
          overflow: "hidden",
        };
      }}
    >
      <Box
        sx={{
          height: "auto",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20%",
        }}
        component={Link}
        to="/dashboard"
      >
        <img
          src={sidebarlogo}
          alt="Sidebar Logo"
          style={{ height: "60px", width: "76px" }}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          marginRight: "5px",
          // scrollbarWidth: "none",
          // msOverflowStyle: "none",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "white", // Scroll thumb color
            borderRadius: "999px",
          },
          // "&::-webkit-scrollbar-track": {
          //   backgroundColor: "red", // Scroll track color
          // },
        }}
      >
        <List>
          {visibleMenus.map((item, index) => {
            const { text, path, submenu, icon } = item;
            const hasSubmenu = submenu.length > 0;
            return (
              <ListItem key={index} sx={{ paddingX: 0.5 }}>
                <ListItemButton
                  component={
                    text == "E Library" || text == "OKR" ? "button" : Link
                  }
                  to={{ pathname: path }}
                  // to={{
                  //   pathname:
                  //     text === "Payroll" || text === "Salary"
                  //       ? "/payroll"
                  //       : path,
                  // }}
                  state={{ submenu }}
                  // onClick={(e) => {
                  //   localStorage.removeItem("empType");
                  // }}
                  onClick={(e) => {
                    localStorage.removeItem("empType");
                    if (text === "E Library") {
                      e.preventDefault();

                      // Get user details from localStorage
                      const fullName = `${localStorageData?.userDetails?.firstName} ${localStorageData?.userDetails?.lastName}`;
                      const officialEmail =
                        localStorageData?.userDetails?.officialEmail;
                      const department =
                        localStorageData?.userDetails?.department;
                      // Get client IP (approximation using browser origin + pathname)
                      const clientIP = `${window.location.origin}${window.location.pathname}`;
                      // Encode values in base64
                      const encodedName = btoa(fullName);
                      const encodedEmail = btoa(officialEmail);
                      const encodedDept = btoa(department);
                      const encodedClientIP = btoa(clientIP);
                      // Build the final URL
                      const redirectUrl = `https://magicportal.cavinkare.in/E-Library/public/index.php/custom-login/${encodedName}/${encodedEmail}/${encodedDept}/${encodedClientIP}`;
                      // Redirect
                      // window.location.href = redirectUrl;
                      window.open(redirectUrl, "_blank");
                    } else if (text === "OKR") {
                      e.preventDefault();
                      const officialEmail =
                        localStorageData?.userDetails?.officialEmail;
                      const encodedEncryptedEmail = encryptEmail(officialEmail);
                      generateOKRSSOToken(officialEmail, SECRET_KEY);
                      // const redirectURL = `https://goalsync.in/okr/api/auth/budgielogin?identifier=${encodedEncryptedEmail}`;
                      // const redirectURL = `https://okr.cavinkare.in/sso-login?token=${encodeURIComponent(encodedEncryptedEmail)}`;

                      // window.location.href = redirectURL;
                      // window.open(redirectURL, "_blank");
                    } else if (text === "Referral Program") {
                      e.preventDefault();

                      // Get user details from localStorage

                      const officialEmail =
                        localStorageData?.userDetails?.officialEmail;

                      // Build the final URL
                      const redirectUrl = `https://formbuilder.cavinkare.in/index.php/forms/survey_new/TkRReA%253D%253D?name=${officialEmail}`;
                      // Redirect
                      // window.location.href = redirectUrl;
                      window.open(redirectUrl, "_blank");
                    }
                  }}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingX: 0.5,
                    backgroundColor:
                      location.pathname === path ||
                      submenu.some(
                        (sub) => sub.path === location.pathname,
                        // sub.child.some(
                        //   (child) => child.path === location.pathname
                        // )
                      )
                        ? "white"
                        : "transparent",
                    borderBottomRightRadius:
                      location.pathname === path ||
                      submenu.some(
                        (sub) => sub.path === location.pathname,
                        // sub.child.some(
                        //   (child) => child.path === location.pathname
                        // )
                      )
                        ? "12px"
                        : "0px",
                    borderTopRightRadius:
                      location.pathname === path ||
                      submenu.some(
                        (sub) => sub.path === location.pathname,
                        // sub.child.some(
                        //   (child) => child.path === location.pathname
                        // )
                      )
                        ? "12px"
                        : "0px",
                    borderTopLeftRadius: "5px",
                    borderBottomLeftRadius: "5px",
                    "&:hover": {
                      backgroundColor:
                        location.pathname === path ||
                        submenu.some(
                          (sub) => sub.path === location.pathname,
                          // sub.child.some(
                          //   (child) => child.path === location.pathname
                          // )
                        )
                          ? "white"
                          : "transparent",
                      opacity: 1,
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color:
                        location.pathname === path ||
                        submenu.find(
                          (sub) => sub.path === location.pathname,
                          // sub.child.some(
                          //   (child) => child.path === location.pathname
                          // )
                        )
                          ? "black"
                          : "white",
                      minWidth: 0,
                    }}
                  >
                    <BootstrapTooltip title={text}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          // gap: "0px",
                        }}
                      >
                        <span style={{ lineHeight: "0px" }}>
                          <DynamicIcon iconName={icon} />
                        </span>
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "10px",
                            color:
                              location.pathname === path ||
                              submenu.find(
                                (sub) => sub.path === location.pathname,
                              )
                                ? "black"
                                : "white",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            textAlign: "center",
                            maxWidth: "55px",
                            fontWeight: "300",
                          }}
                        >
                          {text}
                        </Typography>
                      </Box>
                    </BootstrapTooltip>
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>

      {/* Fixed Toggle Button for Menus */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          bottom: {
            xs: "10%",
            xl: "0%",
          },
        }}
      >
        <IconButton
          onClick={() => setShowAllMenus((prev) => !prev)}
          style={{ color: "#ffffff", marginLeft: "16px" }}
        >
          {showAllMenus ? (
            <ExpandLessIcon sx={{ height: "30px", width: "30px" }} />
          ) : (
            <ExpandMoreIcon sx={{ height: "30px", width: "30px" }} />
          )}
        </IconButton>
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "65px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 1,
          backgroundImage: `url(${sidebarfooter})`,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
        }}
      >
        <Box
          sx={{
            position: "relative",
            "&:hover .hover-label": {
              display: "block",
            },
          }}
        >
          <Stack
            justifyContent="center"
            alignItems="center"
            // padding={1}
            // paddingBottom={}
            // paddingTop="12px"
            // borderRadius={5}
            // spacing={2}
            // height="50px"
            sx={{
              backgroundColor: "white",
              // alignItems: "center",
              borderRadius: "80%",
            }}
            aria-label="chat"
            onClick={toggleChat}
          >
            {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: "7px solid #214a32",
              backgroundColor: "transparent",
            }}
          >
            <QuestionMarkIcon
              onClick={() => setOpen(true)}
              sx={{ fontSize: "16px", cursor: "pointer" }}
            />
          </Box> */}
            {/* <LogoutIcon
            sx={{ fontSize: "20px", cursor: "pointer" }}
            onClick={handleLogout}
          /> */}
            {/* <SupportAgentIcon
            sx={{ fontSize: "20px", cursor: "pointer" }}
            onClick={toggleChat}
          /> */}
            <img
              src={helpdeskIcon}
              alt="HR Help Desk Logo"
              style={{ height: "40px", width: "44px", cursor: "pointer" }}
            />
          </Stack>
          <Typography
            // component="span"
            sx={{
              fontSize: "10px",
              color: "#fff",
              whiteSpace: "normal",
              wordBreak: "break-word",
              textAlign: "center",
              maxWidth: "55px",
              fontWeight: "300",
            }}
          >
            Help Desk
          </Typography>
          <Box
            className="hover-label"
            sx={{
              display: "none",
              position: "absolute",
              bottom: "110%",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "black",
              color: "white",
              padding: "4px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              whiteSpace: "nowrap",
              zIndex: 999,
            }}
          >
            HR Help Desk
          </Box>
        </Box>
      </Box>
      {/* Hr Helpdesk Form */}
      {isOpen && (
        <DialogForm
          open={isOpen}
          setOpen={setIsOpen}
          title={"Help Desk"}
          onClose={() => {
            setIsOpen(false);
            setInitialValues({
              reason: "",
              ticketRaisedFor: "My Self",
              menu: "",
              employeeList: "",
              modeOfCommunication: "",
            });
          }}
        >
          <Formik
            key={isOpen}
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
              handleHelpSubmit(values, resetForm);
            }}
          >
            {({ values, resetForm, setErrors, setFieldValue }) => {
              useEffect(() => {
                setTicketRaised(values?.ticketRaisedFor || "My Self");
                setErrors({});
              }, [values?.ticketRaisedFor]);

              return (
                <Form>
                  <Grid item xs={12} sm={6}>
                    <FormikSelectInput
                      name="ticketRaisedFor"
                      label="Ticket Raised For"
                      options={typeOptions}
                      placeholder="Select Raised For"
                      required
                    />
                  </Grid>
                  {ticketRaised != "My Self" && (
                    <Grid item xs={12} sm={6}>
                      <FormikSelectInput
                        search={true}
                        name="employeeList"
                        label="Employee List"
                        options={empOptions}
                        placeholder="Select Employee"
                        required
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6}>
                    <FormikSelectInput
                      name="menu"
                      label="Category"
                      search={true}
                      options={allMenuOptions}
                      placeholder="Select Menu"
                      required
                    />
                  </Grid>

                  {isSpocUser && (
                    <Grid item xs={12} sm={6}>
                      <FormikSelectInput
                        name="modeOfCommunication"
                        label="Mode of Communication"
                        options={modeOfCommunicationOptions}
                        placeholder="Select Mode of Communication"
                        required
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6}>
                    <FormikTextarea
                      label="Reason"
                      name="reason"
                      placeholder="Enter a reason"
                      required
                      inputRestriction="all"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormikFileUpload
                      placeholder="No file chosen"
                      name="file"
                      label="File"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: 1,
                      }}
                    >
                      <Box
                        sx={{
                          px: 2,
                          py: 1,
                          bgcolor: "#1a1a2e",
                          borderRadius: 1,
                          fontWeight: 700,
                          fontSize: "1.2rem",
                          fontFamily: "monospace",
                          fontStyle: "italic",
                          letterSpacing: 4,
                          color: "#e0e0e0",
                          userSelect: "none",
                          textDecoration: "line-through",
                          textDecorationColor: "#555",
                        }}
                      >
                        {captchaText}
                      </Box>
                      <input
                        type="text"
                        value={captchaInput}
                        onChange={(e) => {
                          setCaptchaInput(e.target.value);
                          setCaptchaError("");
                        }}
                        placeholder="Enter CAPTCHA"
                        style={{
                          width: 130,
                          padding: "8px",
                          borderRadius: 4,
                          border: captchaError
                            ? "1px solid red"
                            : "1px solid #ccc",
                          fontSize: "0.9rem",
                        }}
                      />
                      <Button
                        size="small"
                        variant="text"
                        onClick={() => {
                          setCaptchaText(generateCaptcha());
                          setCaptchaInput("");
                          setCaptchaError("");
                        }}
                        sx={{ minWidth: "auto", fontSize: "0.75rem" }}
                      >
                        Refresh
                      </Button>
                    </Box>
                    {captchaError && (
                      <Box sx={{ color: "red", fontSize: "0.75rem", mt: 0.5 }}>
                        {captchaError}
                      </Box>
                    )}
                  </Grid>
                  <Grid container gap={2} justifyContent={"end"} mt={2}>
                    <SubmitButtonWithLoader
                      type="reset"
                      variant="outlined"
                      onClick={() => {
                        setIsOpen(false);
                      }}
                      disabled={loading}
                    >
                      {"Cancel"}
                    </SubmitButtonWithLoader>
                    <SubmitButtonWithLoader
                      loading={loading}
                      type="submit"
                      variant="contained"
                      disabled={
                        loading || !captchaInput || captchaInput !== captchaText
                      }
                    >
                      {"Submit"}
                    </SubmitButtonWithLoader>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </DialogForm>
      )}
    </Box>
  );
  return (
    <>
      {/* <ModalWrapper
        open={open}
        handleClose={() => setOpen(false)}
        initialValues={initialValues}
        fields={fields}
        label={"Help Desk"}
      /> */}
      <DialogForm
        open={open}
        setOpen={setOpen}
        title={"Help Desk"}
        onClose={() => {
          setOpen(false);
          setInitialValues({
            reason: "",
            ticketRaisedFor: "My Self",
            menu: "",
            subMenu: "",
            employeeList: "",
          });
        }}
      >
        <Formik
          key={open}
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            handleHelpSubmit(values, resetForm);
          }}
        >
          {({ values, resetForm, setErrors }) => {
            useEffect(() => {
              setTicketRaised(values?.ticketRaisedFor || "My Self");
              setErrors({});
            }, [values?.ticketRaisedFor]);

            return (
              <Form>
                <Grid item xs={12} sm={6}>
                  <FormikSelectInput
                    name="ticketRaisedFor"
                    label="Ticket Raised For"
                    options={typeOptions}
                    placeholder="Select Raised For"
                    required
                  />
                </Grid>
                {ticketRaised != "My Self" && (
                  <Grid item xs={12} sm={6}>
                    <FormikSelectInput
                      search={true}
                      name="employeeList"
                      label="Employee List"
                      options={empOptions}
                      placeholder="Select Employee"
                      required
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <FormikSelectInput
                    name="menu"
                    label="Menu"
                    search={true}
                    options={allMenuOptions}
                    placeholder="Select Menu"
                    required
                    onChange={(e) => {
                      const matchedMenu = fetchMenu?.menuData?.find(
                        (menu) => menu.commonId === e.target.value,
                      );
                      setSelectedMenuId(matchedMenu?.menuId);
                    }}
                  />
                </Grid>
                {submenuOptions.length > 0 && (
                  <Grid item xs={12} sm={6}>
                    <FormikSelectInput
                      name="subMenu"
                      search={true}
                      label="Sub Menu"
                      options={submenuOptions}
                      placeholder="Select Sub Menu"
                      required
                    />
                  </Grid>
                )}

                {isSpocUser && (
                  <Grid item xs={12} sm={6}>
                    <FormikSelectInput
                      name="modeOfCommunication"
                      label="Mode of Communication"
                      options={modeOfCommunicationOptions}
                      placeholder="Select Mode of Communication"
                      required
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <FormikTextarea
                    label="Reason"
                    name="reason"
                    placeholder="Enter a reason"
                    required
                    inputRestriction="all"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikFileUpload
                    placeholder="No file chosen"
                    name="file"
                    label="File"
                    // handleChange={(event, file) => setFieldValue("file", file)}
                  />
                </Grid>
                <Grid container gap={2} justifyContent={"end"} mt={2}>
                  <Button
                    type="reset"
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    Cancel
                  </Button>

                  <Button type="submit" variant="contained" color="primary">
                    Submit
                  </Button>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </DialogForm>
      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onTransitionEnd={handleDrawerTransitionEnd}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            background: "transparent",
          },
        }}
      >
        {mainDrawer}
      </Drawer>
      <Drawer
        variant="permanent"
        anchor="left"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            height: "100vh",
            overflow: "hidden",
            borderRight: "0px",
            backgroundColor: "#FDF9F6",
          },
        }}
        open
      >
        {mainDrawer}
      </Drawer>
    </>
  );
};

export default DrawerComponent;
